import { isFalsy } from '../utils';

interface ImageUrlProps {
  width: number;
  height: number;
  crop?: string;
  fetchFormat?: string;
  quality?: string;
  backgroundColor?: string;
  noWidth?: boolean;
}

interface BaseConfig {
  width: number;
  ratio: number;
}

const DEFAULTS = {
  crop: 'fit',
  fetchFormat: 'auto',
  quality: 'auto:good',
};

export const buildImageUrl = ({
  width,
  height,
  crop = DEFAULTS.crop,
  fetchFormat = DEFAULTS.fetchFormat,
  quality = DEFAULTS.quality,
  backgroundColor,
  noWidth,
}: ImageUrlProps) => {
  const url = `c_${crop},f_${fetchFormat},h_${height},q_${quality}${noWidth ? '' : ',w_' + width}`;
  return !isFalsy(backgroundColor) ? `b_rgb:${backgroundColor},${url}` : url;
};

export const baseConfig = ({ width, ratio }: BaseConfig) => {
  const { fetchFormat, quality } = DEFAULTS;
  const height = width * ratio;
  const crop = ratio < 1 ? 'fill' : DEFAULTS.crop;

  return {
    fetchFormat,
    quality,
    height,
    crop,
  };
};

export const mergedLayer = ({
  srcSetWidths,
  ratio,
  backgroundColor,
  overlayImageId,
}: {
  srcSetWidths: number[];
  ratio: number;
  backgroundColor: string;
  overlayImageId: string;
}) => {
  return srcSetWidths.map(width => {
    const { fetchFormat, quality, height, crop } = baseConfig({ width, ratio });
    const bgTrans = buildImageUrl({
      width,
      height,
      crop,
      fetchFormat,
      quality: 'auto:best',
      backgroundColor,
    });

    return `${bgTrans}/b_rgb:${backgroundColor},c_${crop},f_${fetchFormat},h_${height},l_${overlayImageId},q_${quality},w_${width}`;
  });
};

export const singleImage = ({ srcSetWidths, ratio, noWidth }: { srcSetWidths: number[]; ratio: number, noWidth?: boolean }) => {
  return srcSetWidths.map(width => {
    const { fetchFormat, quality, height, crop } = baseConfig({ width, ratio });

    return buildImageUrl({
      crop,
      fetchFormat,
      height,
      quality,
      width,
      noWidth,
    });
  });
};
